import {Link, useNavigate} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/Navbar.css";
import { useState, useEffect  } from "react";

const Navbar = () => {

    const navigate = useNavigate();
    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleNavbar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const closeMenu = () => {
        setIsCollapsed(true);
    };

    const returnToLandingPage = () => {
        closeMenu();
        navigate("/");
    };

    useEffect(() => {
        if (!isCollapsed) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [isCollapsed]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setIsCollapsed(true);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            <div
                className={`navbar-overlay ${!isCollapsed ? "visible" : ""}`}
                onClick={closeMenu}
            />

            <nav className="navbar navbar-expand-lg navbar-custom">
                <div className="container-fluid d-flex align-items-center">
                    <Link
                        className="navbar-brand d-flex align-items-center"
                        to="/"
                        onClick={returnToLandingPage}
                    >
                        <img
                            src="/avatar.png"
                            alt="logo"
                            width="70"
                            height="70"
                            className="d-inline-block align-text-top"
                            style={{ borderRadius: "50px", pointerEvents: "none" }}
                        />
                    </Link>

                    <button
                        className="navbar-toggler ms-2"
                        type="button"
                        onClick={toggleNavbar}
                        aria-label="Toggle navigation"
                    >
                        {isCollapsed ? (
                            <span className="navbar-toggler-icon"></span>
                        ) : (
                            <i className="bi bi-x-lg" style={{ fontSize: "2rem", color: "white" }}></i>
                        )}
                    </button>

                    <div
                        className={`collapse navbar-collapse justify-content-center ${
                            !isCollapsed ? "show" : ""
                        }`}
                        style={{ zIndex: 1100 }}
                    >
                        <div className={`navbar-nav ${!isCollapsed ? "" : "ms-auto"} d-flex flex-column flex-lg-row align-items-center`}>
                            <Link to="/about" className={`navbar-link ${!isCollapsed ? "" : "px-3"}`} onClick={closeMenu}>
                                About
                            </Link>
                            <Link to="/projects" className={`navbar-link ${!isCollapsed ? "" : "px-3"}`} onClick={closeMenu}>
                                Projects
                            </Link>
                            <Link to="/contact" className={`navbar-link ${!isCollapsed ? "" : "px-3"}`} onClick={closeMenu}>
                                Contact
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};
export default Navbar;